export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5140.7b901746.jpg";